export default {
    "quarterly": "ربع سنة",
    "by-date": "فلترة بالتاريخ",
    "divide-chart": "تقسيم الرسم البياني",
    "start": "البداية",
    "end": "النهاية"
}